var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTree0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 32 32",
    id: "svg1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer6",
    transform: "translate(0,-64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7-5-1",
    transform: "translate(0,64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9-0-6-3-8-3-6-5-0",
    style: {
      color: "#000000",
      fill: "#a5a664",
      fillOpacity: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      InkscapeStroke: "none"
    },
    d: "m 16,19.5 c -0.235702,0 -0.409801,0.28224 -0.5,0.5 -0.101152,0.244203 0.244203,0.691817 0,0.792969 -0.499318,0.206824 -0.647166,-0.939661 -1.146484,-1.146485 -0.217737,-0.09019 -0.540383,-0.166649 -0.707032,0 -0.166649,0.166649 -0.09019,0.489295 0,0.707032 0.334372,0.807245 1.519144,1.04627 1.853516,1.853515 0.738958,1.784002 -0.738958,4.008967 0,5.792969 0.0902,0.21776 0.264298,0.5 0.5,0.5 0.235702,0 0.409801,-0.28224 0.5,-0.5 1.020489,-2.463679 1.020489,-5.536321 0,-8 -0.0902,-0.21776 -0.264298,-0.5 -0.5,-0.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#7d451b",
      fillOpacity: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      InkscapeStroke: "none"
    },
    d: "m 12,26 a 2,2 0 0 0 -2,2 2,2 0 0 0 2,2 h 8 a 2,2 0 0 0 2,-2 2,2 0 0 0 -2,-2 z",
    id: "path1-04-9-9-2-2-0-3-1-4"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter"
    },
    id: "rect24-59-9",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    rx: 0,
    ry: 2.7755576e-17
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTree0);
export default __webpack_public_path__ + "static/media/icon_tree0.f5bd4e97a3b2a668bbc26b44281a150d.svg";
export { ForwardRef as ReactComponent };